


import { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Paper,
  Divider,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SupportBanner from "../../SupportBanner";
import { useLocation, useNavigate } from "react-router-dom";
import { GoPlusCircle } from "react-icons/go";
import { FiMinusCircle } from "react-icons/fi";
import { MdOutlineMailOutline } from "react-icons/md";
import { IoCallOutline } from "react-icons/io5";
import NewCommonity from "../../Globalassets/NewCommonity";




const HelpSupportMain = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { question, title } = location?.state || {};
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    if (question?.length > 0) {
      setExpanded(0);
    }
  }, [question]);

  const handleAccordionChange = (index) => {
    setExpanded(prev => (prev === index ? null : index));
  };

  return (
    <Box sx={{ backgroundColor: "#fff", minHeight: "100vh" }}>
      {/* <SupportBanner title={title} /> */}
      <Container maxWidth="lg" sx={{ py: 4, paddingTop: '145px' }}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            // display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 3,
            backgroundColor: "rgba(247, 248, 250, 1)",
            p: 3,
          }}
        >
          <Box
            sx={{ display: "flex", alignItems: "center", mb: 2, cursor: "pointer" }}
          // onClick={() => navigate(-1)}
          >
            <img src="/Images/backkk.png" style={{ width: '50px' }} onClick={() => navigate(-1)} />
            <Typography variant="h3" fontWeight="bold" style={{ paddingLeft: '10px' }}>
              Help Center
            </Typography>
          </Box>
          <Paper
            elevation={0}
            sx={{
              borderRadius: 3,
              overflow: "hidden",
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 3,
              backgroundColor: "rgba(247, 248, 250, 1)",
              // p: 3,
            }}
          >
            {/* Sidebar */}

            <Box
              sx={{
                width: { xs: "100%", md: "280px" },
                borderRight: { md: "1px solid #eee" },
                pr: { md: 2 },
              }}
            >

              <Box
                sx={{ display: "flex", alignItems: "center", mb: 4, cursor: "pointer" }}
              >
                {/* <ArrowBackIcon fontSize="small" sx={{ mr: 1 }} /> */}
                <Typography variant="h5" fontWeight="500" style={{ color: 'rgba(102, 112, 133, 1)' }}>
                  {title}
                </Typography>
              </Box>

              {question?.map((item, index) => (
                <Box
                  key={index}
                  sx={{
                    px: 2,
                    py: 1.5,

                    // borderRadius: 2,
                    backgroundColor: expanded === index ? "#fff" : "transparent",
                    borderLeft: expanded === index ? "3px solid #2494C9" : "3px solid transparent",
                    cursor: "pointer",
                    borderTopRightRadius: '8px',
                    borderBottomRightRadius: '8px',
                    mb: 1,
                    fontWeight: 500,
                    color: expanded === index ? "rgba(26, 28, 30, 1)" : "rgba(102, 112, 133, 1)",
                  }}
                  onClick={() => handleAccordionChange(index)}
                >
                  {item.question.length > 30
                    ? `${item.question.slice(0, 30)}...`
                    : item.question}
                </Box>
              ))}
              <Box p={2} sx={{ backgroundColor: '#fff', borderRadius: '15px', paddingTop: '18px' }}>
                <Box>
                  <img src="/Images/ears.png" alt="dummy" style={{ width: '50px', height: '50px' }} />
                  <Box mt={2}>
                    <Typography variant="h4" style={{ color: 'rgba(26, 28, 30, 1)' }}>
                      Still need a support?
                    </Typography>
                    <Typography variant="body2" style={{ color: 'rgba(102, 112, 133, 1)', fontWeight: '400' }}>
                      Leave a message and we will have someone from our team connect with you soon.
                    </Typography>
                  </Box>
                  <Box gap={1} mt={2} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box>
                      <IconButton>
                        <img src="/Images/EMA1.svg" />
                      </IconButton>
                    </Box>
                    <Typography variant="body2" style={{ color: 'rgba(102, 112, 133, 1)' }}>
                      support@bbcorp.trade
                    </Typography>

                  </Box>
                  <Box gap={1} mt={2} mb={3} sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box>
                      <IconButton>
                        <img src="/Images/CALLLLL.svg" />
                        {/* <IoCallOutline color="rgba(3, 19, 40, 1)" /> */}
                      </IconButton>
                    </Box>
                    <Typography variant="body2" style={{ color: 'rgba(102, 112, 133, 1)' }}>
                      +961 01 789101
                    </Typography>

                  </Box>
                </Box>
              </Box>
            </Box>

            {/* Main Content */}
            <Box flex={1}>
              {question?.length > 0 ? (
                question.map((item, index) => (
                  <Accordion
                    key={index}
                    expanded={expanded === index}
                    onChange={() => handleAccordionChange(index)}
                    sx={{
                      borderRadius: 2,
                      boxShadow: "none",
                      backgroundColor: "#f9fafb",
                      mb: 2,
                      "&::before": {
                        display: "none", // ❌ Removes the default MUI top border
                      },
                    }}
                  >
                    <AccordionSummary
                      expandIcon={expanded === index ? <FiMinusCircle size={25} color="rgba(36, 148, 201, 1)" /> : <GoPlusCircle size={25} color="rgba(0, 0, 0, 1)" />}
                      sx={{
                        backgroundColor: "#fff",
                        borderRadius: 2,
                        px: 2,
                        py: 0,
                        fontWeight: "bold",
                        "&::before": {
                          display: "none", // ❌ Also remove internal top border
                        },

                      }}
                    >
                      <Typography variant="h4" style={{ color: 'rgba(26, 28, 30, 1)', fontSize: { xs: "15px" }, fontWeight: '500' }} fontWeight={600}>{item.question}</Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ backgroundColor: "#fff", borderRadius: 2, px: 2, }}>
                      {item.answer.split("\n").map((line, idx) => (
                        <Typography key={idx} variant="body2" sx={{ mb: 1.5, color: "#475467" }}>
                          {line}
                        </Typography>
                      ))}
                    </AccordionDetails>
                  </Accordion>
                ))
              ) : (
                <Typography>Select a question from the left panel</Typography>
              )}
            </Box>
          </Paper>
        </Paper>
        <Box mt={10}>
          <NewCommonity
            title={
              <>
                Need Help?
              </>
            }
            subtitle={
              <>
                If you have a question that isn't covered in the Help Centre, please contact<br /> us and one of our representatives will be happy to help you.
              </>
            }
          />
        </Box>

      </Container>
    </Box>
  );
};

export default HelpSupportMain;
